import {
  //
  ADD_CARE_HOME_GROUP,
  ADD_CARE_HOME_GROUP_FAILURE,
  ADD_CARE_HOME_GROUP_SUCCESS,
  //
  DELETE_CARE_HOME_GROUP,
  DELETE_CARE_HOME_GROUP_FAILURE,
  DELETE_CARE_HOME_GROUP_SUCCESS,
  //
  EDIT_CARE_HOME_GROUP,
  EDIT_CARE_HOME_GROUP_FAILURE,
  EDIT_CARE_HOME_GROUP_SUCCESS,
  //
  FETCH_CARE_HOME_GROUPS,
  FETCH_CARE_HOME_GROUPS_FAILURE,
  FETCH_CARE_HOME_GROUPS_SUCCESS,
  //
  GET_VIEW_DATA,
  GET_VIEW_DATA_FAILURE,
  GET_VIEW_DATA_SUCCESS,
  //
  SEARCH_CARE_HOME_GROUP,
  SEARCH_CARE_HOME_GROUP_SUCCESS,
  SEARCH_CARE_HOME_GROUP_FAILURE,
} from "./constants";

// List
export const fetchCareHomeGroups = (payload) => ({
  type: FETCH_CARE_HOME_GROUPS,
  payload,
});
export const fetchCareHomeGroupsSuccess = (payload) => ({
  type: FETCH_CARE_HOME_GROUPS_SUCCESS,
  payload,
});
export const fetchCareHomeGroupsFailure = (payload) => ({
  type: FETCH_CARE_HOME_GROUPS_FAILURE,
  payload,
});
// View
export const getViewData = (payload) => ({
  type: GET_VIEW_DATA,
  payload,
});
export const getViewDataSuccess = (payload) => ({
  type: GET_VIEW_DATA_SUCCESS,
  payload,
});
export const getViewDataFailure = (payload) => ({
  type: GET_VIEW_DATA_FAILURE,
  payload,
});
// ADD
export const addCareHomeGroup = (payload) => ({
  type: ADD_CARE_HOME_GROUP,
  payload,
});
export const addCareHomeGroupSuccess = (payload) => ({
  type: ADD_CARE_HOME_GROUP_SUCCESS,
  payload,
});
export const addCareHomeGroupFailure = (payload) => ({
  type: ADD_CARE_HOME_GROUP_FAILURE,
  payload,
});
// EDIT
export const editCareHomeGroup = (payload) => ({
  type: EDIT_CARE_HOME_GROUP,
  payload,
});
export const editCareHomeGroupSuccess = (payload) => ({
  type: EDIT_CARE_HOME_GROUP_SUCCESS,
  payload,
});
export const editCareHomeGroupFailure = (payload) => ({
  type: EDIT_CARE_HOME_GROUP_FAILURE,
  payload,
});
// DELETE
export const deleteCareHomeGroup = (payload) => ({
  type: DELETE_CARE_HOME_GROUP,
  payload,
});
export const deleteCareHomeGroupSuccess = (payload) => ({
  type: DELETE_CARE_HOME_GROUP_SUCCESS,
  payload,
});
export const deleteCareHomeGroupFailure = (payload) => ({
  type: DELETE_CARE_HOME_GROUP_FAILURE,
  payload,
});
// SEARCH
export const searchCareHome = (payload) => ({
  type: SEARCH_CARE_HOME_GROUP,
  payload,
});
export const searchCareHomeSuccess = (payload) => ({
  type: SEARCH_CARE_HOME_GROUP_SUCCESS,
  payload,
});
export const searchCareHomeFailure = (payload) => ({
  type: SEARCH_CARE_HOME_GROUP_FAILURE,
  payload,
});
